export const ACCOUNT = 'ACCOUNT'
export const ACCOUNT_PREFERENCES = 'ACCOUNT_PREFERENCES'
export const INTEGRATION_PROVIDER = 'INTEGRATION_PROVIDER'
